var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yd-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.visible,
        "append-to-body": "",
        width: "60%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.closeDataView,
        open: _vm.openData,
      },
    },
    [
      _c(
        "div",
        [
          _c("div", { staticClass: "top-box" }, [
            _c(
              "div",
              [
                _c("el-tag", { attrs: { type: "danger", effect: "dark" } }, [
                  _c("div", [_vm._v("曝光量")]),
                  _c("div", [
                    _vm._v(_vm._s(_vm.advertisingData.totalExposureNum || 0)),
                  ]),
                ]),
                _c("el-tag", { attrs: { type: "warning", effect: "dark" } }, [
                  _c("div", [_vm._v("点击量")]),
                  _c("div", [
                    _vm._v(_vm._s(_vm.advertisingData.totalClickNum || 0)),
                  ]),
                ]),
                _c("el-tag", { attrs: { type: "success", effect: "dark" } }, [
                  _c("div", [_vm._v("点击率")]),
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.advertisingData.totalPercentage || 0) + "%"
                    ),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "div",
              [
                _c("el-date-picker", {
                  staticStyle: { width: "220px" },
                  attrs: {
                    format: "yyyy-MM-dd",
                    "value-format": "yyyy-MM-dd",
                    type: "daterange",
                    "range-separator": "至",
                    "start-placeholder": "开始日期",
                    "end-placeholder": "结束日期",
                    "picker-options": _vm.pickerOptions,
                    size: "mini",
                  },
                  on: { change: _vm.daterangeChange },
                  model: {
                    value: _vm.daterange,
                    callback: function ($$v) {
                      _vm.daterange = $$v
                    },
                    expression: "daterange",
                  },
                }),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "select-box" },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择", clearable: "", size: "mini" },
                  model: {
                    value: _vm.chartType,
                    callback: function ($$v) {
                      _vm.chartType = $$v
                    },
                    expression: "chartType",
                  },
                },
                _vm._l(_vm.chartTypeList, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              ref: "myChart",
              staticClass: "test2",
              staticStyle: { width: "600px", height: "400px" },
            },
            [
              _c("div", {
                staticStyle: { width: "100%", height: "278px" },
                attrs: { id: "myChart" },
              }),
            ]
          ),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.records,
                border: "",
                size: "mini",
                "max-height": "220",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "日期", prop: "recordDate", align: "center" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "曝光量",
                  prop: "exposureNum",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "点击量", prop: "clickNum", align: "center" },
              }),
              _c("el-table-column", {
                attrs: { label: "点击率", prop: "endTime", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              (scope.row.percentage * 100 || 0).toFixed(2)
                            ) +
                            "%\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "对比", prop: "percentage", align: "center" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.closeDataView } }, [
            _vm._v("返 回"),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }